import React from 'react';
import MDEditor from '@uiw/react-md-editor';
import styles from './MarkdownEditorWrapper.module.scss';

const MarkdownEditorWrapper = ({ value, onChange, ...rest }) => {
  return (
    <div className={styles.editorBoundary}>
      <MDEditor
        value={value}
        onChange={onChange}
        data-color-mode={rest['data-color-mode'] || 'light'}
        {...rest}
      />
    </div>
  );
};

export default MarkdownEditorWrapper;
